import React, { Component } from "react";
import {Col, Row} from "antd";
import {connect} from "react-redux";
import {
  getGlobalEventStats
} from "../../../actions/thunks/eventStats";
import AppTypeStatsCard from "./AppTypeStatsCard";
import EventCharts from "./EventCharts";
import EventCardFeetching from "../../feetching/EventCardFeetching";

 class AppTypeStats extends Component {

   constructor(props) {
     super(props);

     this.state = {
       appType: 'global',
     };
   }

   handleAppTypeSelect = (appType) => {
     this.setState({
       appType: appType,
     });
   };

   componentDidMount() {
     this.getEventStats();
   }

   componentDidUpdate(nextProps, nextState, nextContext) {

     if (nextProps.eventStatsFilter.year !== this.props.eventStatsFilter.year || nextProps.eventStatsFilter.startMonth !== this.props.eventStatsFilter.startMonth || nextProps.eventStatsFilter.endMonth !== this.props.eventStatsFilter.endMonth || nextProps.eventStatsFilter.season !== this.props.eventStatsFilter.season) {
       this.getEventStats();
     }
   }

   getEventStats = () => {
     let params = {};

     if (this.props.eventStatsFilter.year.length > 0) {
       params.year = this.props.eventStatsFilter.year;
     }

     if(this.props.auth.currentClient) {
       params.issuerId = this.props.auth.currentClient.id;
     }


     params.startMonth = this.props.eventStatsFilter.startMonth;
     params.endMonth = this.props.eventStatsFilter.endMonth;
     params.season = isNaN(this.props.eventStatsFilter.season) ? this.props.eventStatsFilter.season : Number(this.props.eventStatsFilter.season);


     this.props.getGlobalEventStats(params);
   }

  render() {
    const { appType } = this.state;
    const {fetching, fetched} = this.props.eventStatsGlobal;
    const { all_in, cycle, formation }= this.props.eventStatsGlobal.items;

    if(formation && formation.hasNotPaidUserIds){
      formation.hasNotPaidUserIds = Object.values(formation.hasNotPaidUserIds);
      formation.hasPaidUserIds = Object.values(formation.hasPaidUserIds);
      cycle.hasNotPaidUserIds = Object.values(cycle.hasNotPaidUserIds);
      cycle.hasPaidUserIds = Object.values(cycle.hasPaidUserIds);
      all_in.hasNotPaidUserIds = Object.values(all_in.hasNotPaidUserIds);
      all_in.hasPaidUserIds = Object.values(all_in.hasPaidUserIds);
    }

    return (
    <div>
      <Row>
        <Col span={6}>
          {
            fetching ? <EventCardFeetching appType={'global'}/> :
              <div onClick={() => this.handleAppTypeSelect('global')}>
                <AppTypeStatsCard selected={appType === 'global'} appType={'global'} formation={formation && formation} cycle={cycle && cycle} all_in={all_in && all_in}/>
              </div>
          }
        </Col>
        <Col span={6}>
          {
            fetching ? <EventCardFeetching appType={'registering'}/> :
              <div onClick={() => this.handleAppTypeSelect('registering')}>
                <AppTypeStatsCard selected={appType === 'registering'} appType={'registering'} nbrActivities={formation && formation.nbrActivities} paidRegistrant={formation && formation.paidRegistrant} notpaidRegistrant={formation && formation.hasNotPaidUserIds.length} inDistinctPaidRegistrant={formation && formation.inDistinctPaidRegistrant} inDistinctNotPaidRegistrant={formation && formation.notPaidRegistrant} hasPaidUserIds={formation && formation.hasPaidUserIds} hasNotPaidUserIds={formation && formation.hasNotPaidUserIds} />
              </div>
          }
        </Col>
        <Col span={6}>
          {
            fetching ? <EventCardFeetching appType={'cycle_registering'}/> :
              <div onClick={() => this.handleAppTypeSelect('cycle_registering')}>
                <AppTypeStatsCard selected={appType === 'cycle_registering'} appType={'cycle_registering'} nbrActivities={cycle && cycle.nbrActivities} paidRegistrant={cycle && cycle.paidRegistrant} notpaidRegistrant={cycle && cycle.hasNotPaidUserIds.length} inDistinctPaidRegistrant={cycle && cycle.inDistinctPaidRegistrant} inDistinctNotPaidRegistrant={cycle && cycle.notPaidRegistrant} hasPaidUserIds={cycle && cycle.hasPaidUserIds} hasNotPaidUserIds={cycle && cycle.hasNotPaidUserIds}/>
              </div>
          }
        </Col>
        <Col span={6}>
          {
            fetching ? <EventCardFeetching appType={'cycle_registering'}/> :
              <div onClick={() => this.handleAppTypeSelect('all_in')}>
                <AppTypeStatsCard selected={appType === 'all_in'} appType={'all_in'} nbrActivities={all_in && all_in.nbrActivities} paidRegistrant={all_in && all_in.paidRegistrant} notpaidRegistrant={all_in && all_in.hasNotPaidUserIds.length} inDistinctPaidRegistrant={all_in && all_in.inDistinctPaidRegistrant} inDistinctNotPaidRegistrant={all_in && all_in.notPaidRegistrant} hasPaidUserIds={all_in && all_in.hasPaidUserIds} hasNotPaidUserIds={all_in && all_in.hasNotPaidUserIds}/>
              </div>
          }
        </Col>
      </Row>
      <div className={appType=='global' ? 'event-stats-row-container event-charts event-charts-blue mr-4 mt-4' :
        (appType=='registering' ? 'event-stats-row-container event-charts event-charts-light-blue mr-4 mt-4' :
            (appType=='cycle_registering' ? 'event-stats-row-container event-charts event-charts-orange mr-4 mt-4' : 'event-stats-row-container event-charts event-charts-pink mr-4 mt-4')
        )
      }>
        {
          fetched && <EventCharts event={appType == 'global' ? this.props.eventStatsGlobal.items :
            (appType == 'registering' ? formation :
                (appType == 'cycle_registering' ? cycle : all_in)
            )}/>
        }
      </div>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventStatsGlobal: state.eventStatsGlobal,
  auth: state.auth,
});

const mapDispatchToProps = {
  getGlobalEventStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppTypeStats);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/AppTypeStats.js